import BS_giadinhSvg from "./svg/BS_giadinh.svg";
import K03Svg from "./svg/K03.svg";
import K08Svg from "./svg/K08.svg";
import K13Svg from "./svg/K13.svg";
import K16Svg from "./svg/K16.svg";
import K17Svg from "./svg/K17.svg";
import K18Svg from "./svg/K18.svg";
import K19Svg from "./svg/K19.svg";
import K27Svg from "./svg/K27.svg";
import K28Svg from "./svg/K28.svg";
import K29Svg from "./svg/K29.svg";
import K30Svg from "./svg/K30.svg";
import K31Svg from "./svg/K31.svg";
import K39Svg from "./svg/K39.svg";
import NoSvg from "./svg/No.svg";
import digestiveSvg from "./svg/digestive.svg";

/**
 * Specialty icons from the app's design kit: a navy glyph on a white disc. They sit on a 100px tile -
 * light in lists, navy for the specialty being viewed - and a parent can resize the tile.
 */
const specialtyIcon = (src: string, active = false) =>
  function SpecialtyIcon() {
    return (
      <div
        className={`flex items-center justify-center w-[100px] h-[100px] rounded-2xl ${
          active ? "bg-gradient-to-b from-common-primary400 to-common-primary" : "bg-common-primary50"
        }`}
      >
        <img className="w-[76%] h-[76%]" src={src} alt="" />
      </div>
    );
  };

export const K03 = specialtyIcon(K03Svg);
export const K08 = specialtyIcon(K08Svg);
export const K13 = specialtyIcon(K13Svg);
export const K16 = specialtyIcon(K16Svg);
export const K17 = specialtyIcon(K17Svg);
export const K18 = specialtyIcon(K18Svg);
export const K19 = specialtyIcon(K19Svg);
export const K27 = specialtyIcon(K27Svg);
export const K28 = specialtyIcon(K28Svg);
export const K29 = specialtyIcon(K29Svg);
export const K30 = specialtyIcon(K30Svg);
export const K31 = specialtyIcon(K31Svg);
export const K39 = specialtyIcon(K39Svg);
export const BS_giadinh = specialtyIcon(BS_giadinhSvg);
export const Digestive = specialtyIcon(digestiveSvg);
export const No = specialtyIcon(NoSvg);

export const K03A = specialtyIcon(K03Svg, true);
export const K08A = specialtyIcon(K08Svg, true);
export const K13A = specialtyIcon(K13Svg, true);
export const K16A = specialtyIcon(K16Svg, true);
export const K17A = specialtyIcon(K17Svg, true);
export const K18A = specialtyIcon(K18Svg, true);
export const K19A = specialtyIcon(K19Svg, true);
export const K27A = specialtyIcon(K27Svg, true);
export const K28A = specialtyIcon(K28Svg, true);
export const K29A = specialtyIcon(K29Svg, true);
export const K30A = specialtyIcon(K30Svg, true);
export const K31A = specialtyIcon(K31Svg, true);
export const K39A = specialtyIcon(K39Svg, true);
export const BS_giadinhA = specialtyIcon(BS_giadinhSvg, true);
export const DigestiveA = specialtyIcon(digestiveSvg, true);
export const NoA = specialtyIcon(NoSvg, true);
